/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { Rules } from './rules';

export class MenuTemplate extends DaoModel {
  constructor(guid, name_es, name_en, rules) {
    super(guid);
    this.name_es = name_es || '';
    this.name_en = name_en || '';
    this.rules = rules;
  }

  static toInstance(props = {}) {
    const rules = Rules.toInstance(props.rules);
    return new MenuTemplate(props.guid, props.name_es, props.name_en, rules);
  }

  get name() {
    return this.translateAttribute('name');
  }

  getAllowedChildren(codeName) {
    if (this.rules.creationConstraints[codeName]) return this.rules.creationConstraints[codeName];
    return [];
  }

  isOperationDisallowed(namespace, operation) {
    // Namespaces: 'PRODUCT', 'THEME'
    // Example: currentTemplate.isOperationDisallowed("PRODUCT", "SPECIAL")
    return !!(this.rules.disallowedOperations[namespace] && this.rules.disallowedOperations[namespace].find((el) => el === operation));
  }

  hasSettings() {
    const settings = [['MENU_CONFIGURATION', 'USE_BUTTONS'], ['MENU_CONFIGURATION', 'USE_SHOPPING_CART'], ['MENU_CONFIGURATION', 'USE_PRODUCT_RECOMMENDATIONS'], ['MENU_CONFIGURATION', 'USE_INITIAL_RECOMMENDATIONS'], ['MENU_CONFIGURATION', 'USE_BORDERS_IN_MENU'], ['MENU_CONFIGURATION', 'USE_BORDER_SUBSECTIONS_HEADING'], ['MENU_CONFIGURATION', 'SHOW_ALLERGENS_BY_DEFAULT'], ['MENU_CONFIGURATION', 'USE_TEXT_OUTLINE'], ['MENU_CONFIGURATION', 'USE_PRICE_SETTINGS'], ['MENU_CONFIGURATION', 'USE_HYPHEN_TEXT']];
    return settings.map((setting) => !this.isOperationDisallowed(setting[0], setting[1])).some((allowed) => allowed);
  }

  getWidthAndHeight() {
    return {
      width: this.rules.previewDimensions.x ? this.rules.previewDimensions.x : 414,
      height: this.rules.previewDimensions.y ? this.rules.previewDimensions.y : 736
    };
  }
}
